import React from 'react';
import { RadioButton } from './radio_button';

class RadioGroup extends React.Component {
  buildRadioGroup() {
    return this.props.options.map(option => {
      const display = this.props.strings ? this.props.strings[option.stringKey] : option.display;

      return (
        <div className="form-group">
          <RadioButton
            key={option.value}
            name={this.props.name}
            value={option.value}
            id={`${option.name}-${option.value}`}
            onClick={this.props.onClick}
            checked={this.props.selected == option.value}
          />
          <label htmlFor={`${option.name}-${option.value}`}>{`${display} `}</label>
          {option.content ? option.content : ''}
        </div>
      );
    });
  }

  render() {
    return <div>{this.buildRadioGroup()}</div>;
  }
}

export { RadioGroup };
